import React from "react";
import SponsoredBox from "./CategoryBox/SponsoredBox";
import SponsoredBoxTest from "./CategoryBox/SponsoredBoxTest";
import PremiumBox from "./CategoryBox/PremiumBox";
import VerifiedBox from "./CategoryBox/VerifiedBox";
import NormalBox from "./CategoryBox/NormalBox";
import shortid from "shortid";
import Loader from "../../Common/Loader/";

const vendorTab = props => {
  const getCard = (competitor, categoryName, index) => {
    if (competitor.is_sponsored) {
      return (
        <SponsoredBox
          {...competitor}
          categoryName={categoryName}
          key={shortid.generate()}
          featured={competitor.vendor_position === "featured" ? true : false}
        />
      );
    } else {
      if (competitor.vendor_type === "normal") {
        return (
          <NormalBox
            {...competitor}
            categoryName={categoryName}
            key={shortid.generate()}
            featured={competitor.vendor_position === "featured" ? true : false}
          />
        );
      } else if (competitor.vendor_type === "verified") {
        return (
          <VerifiedBox
            {...competitor}
            categoryName={categoryName}
            key={shortid.generate()}
            featured={competitor.vendor_position === "featured" ? true : false}
          />
        );
      } else if (competitor.vendor_type === "premium") {
        return (
          <PremiumBox
            {...competitor}
            categoryName={categoryName}
            key={shortid.generate()}
            featured={competitor.vendor_position === "featured" ? true : false}
          />
        );
      } else {
        return null;
      }
    }
  };

  return (
    <div className="vendorCategoryList">
      <ul>
        {!!props.results && props.results.length > 0 ? (
          props.results.map((competitor, index) =>
            getCard(competitor, props.category_name, index)
          )
        ) : props.result_count === 0 ? (
          <p>No vendors matching your current filter criteria.</p>
        ) : (
          <Loader />
        )}
      </ul>
    </div>
  );
};

export default vendorTab;
